//
// Copyright 2022 DXOS.org
//
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any, file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_dxos_config } from "../config_pb.js";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
/**
 * Describes the file dxos/service/agentmanager.proto.
 */
export const file_dxos_service_agentmanager = /*@__PURE__*/ fileDesc("Ch9keG9zL3NlcnZpY2UvYWdlbnRtYW5hZ2VyLnByb3RvEhlkeG9zLnNlcnZpY2UuYWdlbnRtYW5hZ2VyIkEKF0luaXRBdXRoU2VxdWVuY2VSZXF1ZXN0EhcKCmF1dGhfdG9rZW4YASABKAlIAIgBAUINCgtfYXV0aF90b2tlbiL3AgoYSW5pdEF1dGhTZXF1ZW5jZVJlc3BvbnNlEloKBnJlc3VsdBgBIAEoDjJKLmR4b3Muc2VydmljZS5hZ2VudG1hbmFnZXIuSW5pdEF1dGhTZXF1ZW5jZVJlc3BvbnNlLkluaXRBdXRoU2VxdWVuY2VSZXN1bHQSEgoFbm9uY2UYAiABKAxIAIgBARIzChBhZ2VudG1hbmFnZXJfa2V5GAMgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleUgBiAEBEiYKGWluaXRfYXV0aF9yZXNwb25zZV9yZWFzb24YBCABKAlIAogBASJRChZJbml0QXV0aFNlcXVlbmNlUmVzdWx0EgsKB1VOS05PV04QABILCgdTVUNDRVNTEAESEgoOTk9UX0FVVEhPUklaRUQQAhIJCgVFUlJPUhADQggKBl9ub25jZUITChFfYWdlbnRtYW5hZ2VyX2tleUIcChpfaW5pdF9hdXRoX3Jlc3BvbnNlX3JlYXNvbiJLCg5BdXRoZW50aWNhdGlvbhI5CgxwcmVzZW50YXRpb24YASABKAsyIy5keG9zLmhhbG8uY3JlZGVudGlhbHMuUHJlc2VudGF0aW9uIn8KFEF1dGhlbnRpY2F0ZVJlc3BvbnNlEhIKBXRva2VuGAEgASgJSACIAQESOgoKY3JlZGVudGlhbBgCIAEoCzIhLmR4b3MuaGFsby5jcmVkZW50aWFscy5DcmVkZW50aWFsSAGIAQFCCAoGX3Rva2VuQg0KC19jcmVkZW50aWFsMvcBCgxBZ2VudE1hbmFnZXISewoQSW5pdEF1dGhTZXF1ZW5jZRIyLmR4b3Muc2VydmljZS5hZ2VudG1hbmFnZXIuSW5pdEF1dGhTZXF1ZW5jZVJlcXVlc3QaMy5keG9zLnNlcnZpY2UuYWdlbnRtYW5hZ2VyLkluaXRBdXRoU2VxdWVuY2VSZXNwb25zZRJqCgxBdXRoZW50aWNhdGUSKS5keG9zLnNlcnZpY2UuYWdlbnRtYW5hZ2VyLkF1dGhlbnRpY2F0aW9uGi8uZHhvcy5zZXJ2aWNlLmFnZW50bWFuYWdlci5BdXRoZW50aWNhdGVSZXNwb25zZUI6WjhnaXRodWIuY29tL2R4b3MvZHhvcy9wcm90by9kZWYvZHhvcy9zZXJ2aWNlL2FnZW50bWFuYWdlcmIGcHJvdG8z", [file_google_protobuf_any, file_google_protobuf_empty, file_dxos_config, file_dxos_halo_credentials, file_dxos_keys]);
/**
 * Describes the message dxos.service.agentmanager.InitAuthSequenceRequest.
 * Use `create(InitAuthSequenceRequestSchema)` to create a new message.
 */
export const InitAuthSequenceRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_service_agentmanager, 0);
/**
 * Describes the message dxos.service.agentmanager.InitAuthSequenceResponse.
 * Use `create(InitAuthSequenceResponseSchema)` to create a new message.
 */
export const InitAuthSequenceResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_service_agentmanager, 1);
/**
 * @generated from enum dxos.service.agentmanager.InitAuthSequenceResponse.InitAuthSequenceResult
 */
export var InitAuthSequenceResponse_InitAuthSequenceResult;
(function (InitAuthSequenceResponse_InitAuthSequenceResult) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    InitAuthSequenceResponse_InitAuthSequenceResult[InitAuthSequenceResponse_InitAuthSequenceResult["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: SUCCESS = 1;
     */
    InitAuthSequenceResponse_InitAuthSequenceResult[InitAuthSequenceResponse_InitAuthSequenceResult["SUCCESS"] = 1] = "SUCCESS";
    /**
     * @generated from enum value: NOT_AUTHORIZED = 2;
     */
    InitAuthSequenceResponse_InitAuthSequenceResult[InitAuthSequenceResponse_InitAuthSequenceResult["NOT_AUTHORIZED"] = 2] = "NOT_AUTHORIZED";
    /**
     * @generated from enum value: ERROR = 3;
     */
    InitAuthSequenceResponse_InitAuthSequenceResult[InitAuthSequenceResponse_InitAuthSequenceResult["ERROR"] = 3] = "ERROR";
})(InitAuthSequenceResponse_InitAuthSequenceResult || (InitAuthSequenceResponse_InitAuthSequenceResult = {}));
/**
 * Describes the enum dxos.service.agentmanager.InitAuthSequenceResponse.InitAuthSequenceResult.
 */
export const InitAuthSequenceResponse_InitAuthSequenceResultSchema = /*@__PURE__*/ enumDesc(file_dxos_service_agentmanager, 1, 0);
/**
 * Describes the message dxos.service.agentmanager.Authentication.
 * Use `create(AuthenticationSchema)` to create a new message.
 */
export const AuthenticationSchema = /*@__PURE__*/ messageDesc(file_dxos_service_agentmanager, 2);
/**
 * Describes the message dxos.service.agentmanager.AuthenticateResponse.
 * Use `create(AuthenticateResponseSchema)` to create a new message.
 */
export const AuthenticateResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_service_agentmanager, 3);
/**
 * @generated from service dxos.service.agentmanager.AgentManager
 */
export const AgentManager = /*@__PURE__*/ serviceDesc(file_dxos_service_agentmanager, 0);
//# sourceMappingURL=agentmanager_pb.js.map